
export default {
  async asyncData({ $axios, error, store }) {
    if (store.state.country === "it" || store.state.country === "cn") {
      try {
        const { data } = await $axios.$get("api/front/pages/cookie-policy");

        return {
          title: "common.cookie_policy",
          content: data.content,
          hasError: false,
        };
      } catch (e) {
        return {
          hasError: true,
        };
      }
    }
  },
  data() {
    return {
      iubendaEmbedUrl: null,
      hasError: false,
      content: "",
    };
  },
  async mounted() {
    if (
      this.$store.state.country != "it" ||
      this.$store.state.country != "cn" ||
      this.hasError
    ) {
      this.iubendaEmbedUrl = this.$loadIubendaEmbedScript("cookie-policy");
    }
  },
  head() {
    return {
      title: this.$t("common.cookie_policy"),
    };
  },
};
